
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M4.643 10.214H2.5v1.188m0 1.91V14.5h2.143m2.571 0h2.572m2.571 0H14.5v-1.188m0-1.91v-1.188h-2.143m0-3.428H14.5V2.5h-12v4.286h2.357m5.357 0L8.5 5m0 0L6.786 6.786M8.5 5v5.5"}})])
          )
        }
      }
    